import { AccountFilterRequest, AccountPost } from "callable-data-objects";
import Account from "callable-data-objects/dist/models/account/Account";
import Page from "callable-data-objects/dist/services/Page";
import AccountDetails from "Components/Account/AccountDetails";
import AccountListHolder from "Components/Account/AccountListHolder";
import useCheckRole from "Hooks/APICheckRole";
import { useAccount } from "Hooks/Endpoints";
import { APIAccountProps } from "Providers/types";
import React, { Fragment } from "react";
import { Header, Icon, Segment } from "semantic-ui-react";
import AccountCreate from "./AccountCreate";

const AccountView = () => {
  const { hasRole, roles } = useCheckRole();
  const {
    account,
    accounts,
    search,
    select,
    unselect,
    validateDomain,
    validateName,
    createAccount,
    save,
    create,
    uncreate,
    submitting,
    filter,
    setFilter,
  }: APIAccountProps = useAccount();
  if (create)
    return renderCreateView(
      create,
      save,
      validateDomain,
      validateName,
      uncreate
    );
  else if (!account && hasRole(roles.account.roles.view)) {
    return renderListView(
      accounts,
      search,
      select,
      createAccount,
      filter,
      setFilter
    );
  } else if (account) {
    return renderAccountDetailView(account, unselect, submitting);
  } else {
    return (
      <Segment placeholder textAlign='center'>
        <Header icon as='h3'>
          <Icon name='warning' color='yellow' />
          Sorry you are not authorised to view this page
        </Header>
      </Segment>
    );
  }
};

const renderListView = (
  accounts: Page<Account> | undefined,
  search: Function,
  select: Function,
  createAccount: Function,
  filter: AccountFilterRequest,
  setFilter: React.Dispatch<React.SetStateAction<AccountFilterRequest>>
) => {
  if (accounts) {
    return (
      <AccountListHolder
        accounts={accounts}
        search={search}
        select={select}
        createAccount={createAccount}
        filter={filter}
        setFilter={setFilter}
      />
    );
  }
  return <Fragment />;
};

const renderAccountDetailView = (
  account: Account,
  unselect: Function,
  submitting: boolean
) => {
  return (
    <AccountDetails
      account={account}
      unselect={unselect}
      submitting={submitting}
    />
  );
};

const renderCreateView = (
  create: AccountPost,
  save: Function,
  validateDomain: Function,
  validateName: Function,
  uncreate: Function
) => {
  return (
    <AccountCreate
      create={create}
      save={save}
      validateDomain={validateDomain}
      validateName={validateName}
      cancel={uncreate}
    />
  );
};

export default AccountView;
